var indexOf = require('./indexOf');

    /**
     * If array contains values.
     */
    function contains(arr, val) {
        return indexOf(arr, val) !== -1;
    }
    module.exports = contains;




//////////////////
// WEBPACK FOOTER
// ./node_modules/mout/array/contains.js
// module id = 61
// module chunks = 0